import { Component, Input } from '@angular/core';
import { ValidationErrors, FormGroup } from '@angular/forms';

@Component({
    selector: 'cs-field-validation',
    templateUrl: './field-validation.component.html'
})
export class FieldValidationComponent {

    @Input()
    public control: any;

    @Input()
    crossValidation: string = undefined;

    @Input()
    formGroup: FormGroup = undefined;

    @Input()
    public submitted: boolean;
}